import { MarketSelector } from '@src/components/MarketSelector/MarketSelector';
import { FormControlSizes } from '@talos/kyoko';

import { useIsMobileLayout } from '../../../hooks/useIsMobileLayout';
import {
  usePredictionCardMarketSelector,
  type PredictionCardMarketSelectorParams,
} from './usePredictionCardMarketSelector';

interface PredictionCardMarketSelectorProps extends PredictionCardMarketSelectorParams {
  'data-testid'?: string;
}

export function PredictionCardMarketSelector({
  items,
  selectedMarketAccounts,
  selectedAggregation,
  onChangeSelectedMarketAccounts,
  'data-testid': dataTestId,
}: PredictionCardMarketSelectorProps) {
  const isInMobileMode = useIsMobileLayout();
  const marketSelector = usePredictionCardMarketSelector({
    items,
    selectedMarketAccounts,
    selectedAggregation,
    onChangeSelectedMarketAccounts,
  });

  return (
    <div data-testid={dataTestId}>
      <MarketSelector
        size={FormControlSizes.Small}
        marketSelectorAPI={marketSelector}
        showCredentialsOnlyToggle
        panelOffset={8}
        panelPlacement="auto"
        isNarrow={isInMobileMode}
      />
    </div>
  );
}
